<template>
  <div class="rechargeDictConfirm">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="layout">
        <div class="amount">
          <div class="amountCon">
            <p>到账金额（{{ iviMatchPayIDs.includes(this.rechargeData.payMethod) ? '人民币' : '美元' }}）</p>
            <span v-if="iviMatchPayIDs.includes(this.rechargeData.payMethod)&&rechargeData&&rechargeData.amount&&rechargeData.rate">¥{{ Math.round(Utils.accMul(rechargeData.amount,rechargeData.rate)) }} ≈ ${{ rechargeData.amount }}</span>
            <span v-if="!iviMatchPayIDs.includes(this.rechargeData.payMethod)&&rechargeData&&rechargeData.amount&&rechargeData.rate">${{ rechargeData.amount }} ≈ ¥{{ Utils.roundUp(Utils.accMul(rechargeData.amount,rechargeData.rate),0).toFixed(2) }}</span>
            <p v-if="rechargeData&&rechargeData.rate" class="size">今日美元汇率为{{ rechargeData.rate }}，具体到账以实际金额为准</p>
          </div>
          <div class="orderList">
            <ul>
              <li><p>存款账号</p><span>{{ user.loginname }}</span></li>
              <li><p>付款方式</p><span v-if="rechargeData&&rechargeData.payName"><img v-if="rechargeData.payDictCode" :src="require('@/assets/images/recharge/pay_icon/'+rechargeData.payDictCode+'.png')">{{ rechargeData.payName }}</span></li>
            </ul>
          </div>
        </div>
        <div class="userNotice">
          <div class="title">
            <span>转账指引说明</span>
            <p @click="userNoticePop">用户须知<img src="@/assets/images/template/remind.png"></p>
          </div>
          <div class="noticeCon">
            <p>(1)打开手机银行/网银/支付宝/微信，<span>实际转账方式必须与所选方式一致。</span></p>
            <p>(2)转账到合作商户的银行账户，<span>付款金额、转账附言(备注)一定 要正确填写，否则资金将无法及时到账。</span></p>
            <p>(3)转账完成，银行卡成功扣款后，请到个人中心查看额度变动。</p>
          </div>
          <div v-sa="{'deposit_confirmation':{'PType':pageType=='app'?'app端':pageType=='trade'?'H5交易':'用户中心','AccountType':'真实账户','deposit_amount':rechargeData.amount,'payment_channel':rechargeData.payName,'account':user.loginname}}" class="submit" @click="submit"><span>确认存款</span></div>
        </div>
      </div>
      <Chat />
    </div>
    <!--用户须知-->
    <div v-if="isUserNoticePop" class="popFixed">
      <div class="masking" @click="userNoticePop" />
      <div class="tcCon">
        <div class="item">
          <span>用户须知</span>
          <p class="txtLeft">1、如果您的转账5分钟内未能到账，请您联系客服处理；订单的有效时间为15分钟，如您已转账但订单已失效，请您联系客服处理。</p>
          <p class="txtLeft">2、若存款时有赠金活动，请在存款成功后联系客服领取赠金和红包。</p>
          <p class="txtLeft">3、系统将会根据您的存款金额为您匹配签约商户，您的汇款将直接进入签约商户账户，交易过程中的资产由平台托管保护。</p>
        </div>
        <div class="btnCon only">
          <span @click="userNoticePop">知道了</span>
        </div>
      </div>
    </div>
    <FundRichfullDeposit v-if="isFundRichfullDeposit" :encrypted-text="encryptedText" :merchant-id="merchantId" :signed-text="signedText" :submit-u-r-l="submitURL" />
  </div>
</template>

<script>
require('@/assets/css/rechargeDictConfirm.css')
import Header from '@/view/module/Header.vue'
import FundRichfullDeposit from '@/view/recharge/FundRichfullDeposit.vue'
import Chat from '@/view/module/Chat.vue'
import api from '@/plugins/api'
import utils from '@/utils/tradeDataUtil'
import { mapState } from 'vuex'
export default {
  name: 'RechargeDictConfirm',
  components: { Header, FundRichfullDeposit, Chat },
  computed: {
    ...mapState(['user', 'platform', 'currency', 'rechargeData', 'pageType']),
    depositParam: {
      get() {
        return {
          platform: this.platform,
          amount: this.rechargeData.amount,
          payMethod: this.rechargeData.payMethod,
          depositCurrency: this.currency,
          bqwaytype: this.rechargeData.bqwaytype,
          fee: 0
        }
      }
    }
  },
  data() {
    return {
      title: '确认存款',
      rightContent: 'recharge',
      Utils: utils,
      isUserNoticePop: false,
      isFundRichfullDeposit: false,
      encryptedText: '',
      merchantId: '',
      signedText: '',
      submitURL: '',
      iviMatchPayIDs: process.env.VUE_APP_IVI_MATCH_PAY_IDS.split(',').map(id => Number(id))
    }
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    userNoticePop() {
      this.isUserNoticePop = !this.isUserNoticePop
    },
    submit() {
      this.$bus.$emit('loading', false)
      const readyData = this.depositParam

      // if (this.iviMatchPayIDs.includes(this.rechargeData.payMethod)) {
      //   this.$router.push({ path: '/home/iviPayMobile', query: { amount: this.rechargeData.amount, rate: this.rechargeData.rate }})
      //   this.$bus.$emit('loading', true)
      //   return
      // }
      
      
      api.addDeposit(readyData).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            if (res.data.data && res.data.data.mpayPara) {
              const data = res.data.data.mpayPara
              this.isFundRichfullDeposit = true
              this.encryptedText = data.encryptedText
              this.merchantId = data.merchantId
              this.signedText = data.signedText
              this.submitURL = data.submitURL
            }
          }
        }
      })
    }
  }
}
</script>
